var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-indicator t-indicator-clock icon-clock no-minify c-indicator--not-clickable"},[_c('span',{staticClass:"label c-indicator__label"},[_vm._v("\n        "+_vm._s(_vm.timeTextValue)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }